$(document).ready(function() {
   $.ajax({
		url: 'https://shopify.designnbuy.in/alex_fox/designnbuy/pcstudio_config/getPersonalise',
		type: 'post',
        data: $('.product-single__form').serialize(),
		success: function(data) {
           if(data.personalise>=1){
             $('#personalize-design').css('display', 'inline-block');
           } 	
		}
	});
});

$('#personalize-design').on('click', function() {
    $('#personalize-design').text("Processing..");
    $.ajax({
		url: 'https://shopify.designnbuy.in/alex_fox/designnbuy/pcstudio_config/getIframeurl',
		type: 'post',
		data: $('.product-single__form').serialize(),
		success: function(json) {
          window.location.href = json;	
		}
	});
});
